import {translation} from "@2d-front-monorepo/core";
import {JSX, memo, useMemo} from "react";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {Attachments} from "../Attachments";
import {VehicleResult} from "../types/VehicleResult";
import AttachmentsComponent from "./AttachmentsComponent";
import ExpiredAttachmentsComponent from "./ExpiredAttachmentsComponent";

export type VehicleComponentProps = {
	vehicle: VehicleResult;
	filesPrefix: string;
}

function VehicleComponent({vehicle, filesPrefix}: VehicleComponentProps): JSX.Element {
	const data = vehicle.data;
	const expired = useMemo(()=> Attachments.findExpired(vehicle), [vehicle]);

	return (
		<div className="card card--driver">
			<div className="columns gap padded">
				<dl className="title-desc col25">
					<dt>{translation(PermitTranslations.vehicle__plate)}</dt>
					<dd>{vehicle.plate}</dd>
				</dl>
				<dl className="title-desc col25">
					<dt>{translation(PermitTranslations.vehicle__nickname)}</dt>
					<dd>{data?.nickname}</dd>
				</dl>
				<dl className="title-desc col25">
					<dt>{translation(PermitTranslations.vehicle__model)}</dt>
					<dd>{data?.model}</dd>
				</dl>
				<dl className="title-desc col25">
					<dt>{translation(PermitTranslations.vehicle__color)}</dt>
					<dd>{data?.color}</dd>
				</dl>
				<dl className="title-desc col25">
					<dt>{translation(PermitTranslations.vehicle__type)}</dt>
					<dd>{data?.type}</dd>
				</dl>
				<dl className="title-desc col25">
					<dt>{translation(PermitTranslations.vehicle__province)}</dt>
					<dd>{data?.province}</dd>
				</dl>
				<AttachmentsComponent entity={vehicle} linkPrefix={filesPrefix} className="col100"/>
				<ExpiredAttachmentsComponent attachments={expired} linkPrefix={filesPrefix} className="col100"/>
			</div>
		</div>
	);
}

const MemoizedVehicleComponent: React.FC<VehicleComponentProps> = memo(VehicleComponent);
export default MemoizedVehicleComponent;
